module.exports = __webpack_public_path__ + "img/arps.aedb58e6.svg";